import React from 'react';
import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const TopVendorsChart = ({ data, isLoading }) => {
    // Expected: [{ name: "Pizza Hut", totalOrders: 150, gmv: 50000, revenue: 5000 }, ...]

    return (
        <Card sx={{ borderRadius: 3, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
            <CardContent>
                <Typography variant="h6" fontWeight={700} mb={3}>
                    Top Performing Vendors
                </Typography>
                {isLoading ? (
                    <Skeleton variant="rectangular" height={300} width="100%" sx={{ borderRadius: 2 }} />
                ) : (
                    <Box sx={{ height: 350, width: '100%' }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={data} layout="vertical" margin={{ left: 40, right: 20 }}>
                                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#f0f0f0" />
                                <XAxis type="number" hide />
                                <YAxis
                                    dataKey="name"
                                    type="category"
                                    width={100}
                                    tick={{ fontSize: 13, fontWeight: 600 }}
                                    axisLine={false}
                                    tickLine={false}
                                />
                                <Tooltip
                                    cursor={{ fill: 'transparent' }}
                                    contentStyle={{ borderRadius: 8 }}
                                    formatter={(value, name) => {
                                        if (name === 'gmv' || name === 'revenue') return `₦${value.toLocaleString()}`;
                                        return value;
                                    }}
                                />
                                <Bar dataKey="totalOrders" name="Orders" barSize={20} radius={[0, 4, 4, 0]}>
                                    {data?.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={index % 2 === 0 ? '#4e73df' : '#36b9cc'} />
                                    ))}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default TopVendorsChart;
